import { BROKEN_SUBSCRIPTION_EDIT_DENIED_QUERY } from '@/features/brokenSubscriptions';

import { usePermissions } from '@/shared/hooks/usePermissions';

import { USER_PERMISSIONS } from '@/shared/types/permissions';

import React, { Suspense } from 'react';

import { Navigate, createSearchParams, useParams } from 'react-router-dom';

import { PageLoader } from './PageLoader';

import { BrokenSubscriptionDetailPage } from '../lazyPages';

export const BrokenSubscriptionEditRoute: React.FC = () => {
  const { shopifyCustomerId } = useParams<{ shopifyCustomerId: string }>();
  const { hasPermission } = usePermissions();
  if (!shopifyCustomerId) {
    return <Navigate to="/broken-subscriptions" replace />;
  }
  if (!hasPermission(USER_PERMISSIONS.BrokenSubscriptionsEdit)) {
    const deniedSearch = createSearchParams({
      [BROKEN_SUBSCRIPTION_EDIT_DENIED_QUERY]: '1',
    }).toString();
    return (
      <Navigate to={`/broken-subscriptions/${shopifyCustomerId}/view?${deniedSearch}`} replace />
    );
  }
  return (
    <Suspense fallback={<PageLoader />}>
      <BrokenSubscriptionDetailPage mode="edit" />
    </Suspense>
  );
};
